import React from 'react';
import styles from '../view.module.css';

export const ReviewActions = ({
  can_save_draft = false,
  acting = null,
  onApprove = () => {},
  onSaveDraft = () => {},
  onReject = () => {}
}) => {
  const is_busy = !!acting;

  return (
    <div className={styles.actionBar}>
      <div className={styles.actionButtons}>
        <button className={styles.rejectBtn} onClick={onReject} disabled={is_busy} type="button">
          Reject
        </button>
        <button
          className={styles.draftBtn}
          onClick={onSaveDraft}
          disabled={is_busy || !can_save_draft}
          type="button"
        >
          {acting === 'save' ? 'Saving…' : 'Save draft'}
        </button>
        <button className={styles.approveBtn} onClick={onApprove} disabled={is_busy} type="button">
          {acting === 'approve' ? 'Approving…' : 'Approve'}
        </button>
      </div>
    </div>
  );
};
